export default {
  STANDALONE: true,
  HOST: 'https://asta-live.com',
  HOST_FANTAPAZZ: 'https://www.fantapazz.com',
  WEBSITE: 'asta-live.com',
  CDN_API_ENDPOINT: 'https://cdn.api.fantapazz.com',
  API_ENDPOINT: 'https://api.fantapazz.com', // serve per listone conf
  // API_TOKEN: "",
  PUBLIC_DIR: "https://fpz.s3-eu-west-1.amazonaws.com/files/public",
  ID_ANNO_MAGLIE: "21",
  AVATAR_OR_FLAG: "avatar",
  MAGLIA_OR_FLAG: "maglia",
  FIREBASE_HOST: 'https://asta-live.com',
  ANNO_ID: "2026-27",
  TORNEO_ID: "seriea",  // usato anche da paypal
  TABLE_NUM_DEFAULT: "",
  LOGIN_DEVELOPER: false,
  GOOGLE_SIGNIN_CLIENT_ID: "78234177896-d6h8hug93i105raf5p2sg5v3t50thr7b.apps.googleusercontent.com",
  GOOGLE_SIGNIN_JS_SDK: "https://accounts.google.com/gsi/client",
  APPLE_SIGNIN_JS_SDK: "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js",
  APPLE_SIGNIN_CLIENT_ID: 'com.aste-standalone-prod-signin', // service ID
  APPLE_SIGNIN_REDIRECT_URI: 'https://asta-live.com',
  FORCE_DISPLAY_NAME: true,
  CREA_ASTA: true,
  TERMINI_E_CONDIZIONI_LINK: "https://www.fantapazz.com/termini-e-condizioni",
  PAYPAL_HOST: "www.paypal.com",
  PREZZI: [{
      legaDa: 2,
      prezzo: 4.99, // // VERO: 4.99, PER DEBUG: 0.01
      buttonId: "ZFFBTUNENY4GL", // VERO: ZFFBTUNENY4GL, PER DEBUG: B78JFEGXZHAPU
    },
    {
      legaDa: 3,
      prezzo: 4.99,
      buttonId: "YCF4TB2UZHMZG",
    },
    {
      legaDa: 4,
      prezzo: 7.99,
      buttonId: "8FJ5PSDWYQ366",
    },
    {
      legaDa: 5,
      prezzo: 7.99,
      buttonId: "WMFKQC5C56Z4Q",
    },
    {
      legaDa: 6,
      prezzo: 10.99,
      buttonId: "4THL7SB3CRNH4",
    },
    {
      legaDa: 7,
      prezzo: 10.99,
      buttonId: "XV8JNNSBYH2EC",
    },
    {
      legaDa: 8,
      prezzo: 14.99,
      buttonId: "2PSUSKVB5WV6G",
    },
    {
      legaDa: 9,
      prezzo: 14.99,
      buttonId: "8VVX8MVMZN84W",
    },
    {
      legaDa: 10,
      prezzo: 16.99,
      buttonId: "2TGVMZYXQ4X3J",
    },
    {
      legaDa: 11,
      prezzo: 16.99,
      buttonId: "DXVQSSJ8DEQNC",
    },
    {
      legaDa: 12,
      prezzo: 18.99,
      buttonId: "WFWD9EPDBSBRN",
    },
    {
      legaDa: 13,
      prezzo: 18.99,
      buttonId: "E7WSW7B72HS2L",
    },
    {
      legaDa: 14,
      prezzo: 18.99,
      buttonId: "22UYFT5FAVHTW",
    },
    {
      legaDa: 15,
      prezzo: 18.99,
      buttonId: "4SCBZDUFW7DYY",
    },
    {
      legaDa: 16,
      prezzo: 18.99,
      buttonId: "E27SRJ5FB4N9S",
    },
    {
      legaDa: 17,
      prezzo: 18.99,
      buttonId: "x77URX8RWAHN84xx",
    },
    {
      legaDa: 18,
      prezzo: 18.99,
      buttonId: "NCLL56SLALD36",
    },
    {
      legaDa: 19,
      prezzo: 18.99,
      buttonId: "MFP7GJQX7RZYY",
    },
    {
      legaDa: 20,
      prezzo: 20.99,
      buttonId: "CDEVAS38CEAYQ",
    },
    {
      legaDa: 21,
      prezzo: 20.99,
      buttonId: "YHBE8LYXS63V2",
    },
    {
      legaDa: 22,
      prezzo: 20.99,
      buttonId: "SJADLJRD7D53W",
    },
    {
      legaDa: 23,
      prezzo: 20.99,
      buttonId: "K5WQ42XL7PLVJ",
    },
    {
      legaDa: 24,
      prezzo: 20.99,
      buttonId: "KDFJY2TMQ7WPL",
    },
  ],
}
